
import { ApiURLs,imageBaseUrls } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";
import { hideAddVehiclesModal } from "./vehiclesModalDispatcher";

  

  export const addVehicleRequest = (data, navigate) => {
    return async (dispatch) => {
      dispatch({"type":"ADD_VEHICLES_REQUEST"});
      try {
        var vehiclesResponse = (data.id)? await updateData(data, `${ApiURLs.VEHICLES}/${data.id}`):await postData(data, ApiURLs.VEHICLES);
        if (vehiclesResponse.status === 1) {
          dispatch({"type":"ADD_VEHICLES_SUCCESS"});
          dispatch(hideAddVehiclesModal());
          dispatch(vehiclesLisitingRequest());
        } else {
          dispatch({"type":"ADD_VEHICLES_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_VEHICLES_FAILED"});
  
      }
    };
  };



  export const addBulkVehicleRequest = (data, navigate) => {
    return async (dispatch) => {
      dispatch({"type":"ADD_VEHICLES_REQUEST"});
      try {
        console.log(`Add BULK DATA  1 ${data}`)


        if (data.file) {
          var uploadedFile = await uploadImage(
            ApiURLs.UPLOAD_IMAGE, "image",
            data.file,
            "vehicle"
          );
          console.log(`Add BULK DATA   2 ${JSON.stringify(uploadedFile)}`)

          data.csvUrl = `${imageBaseUrls(uploadedFile.data.file.filename)}`
        }
        

        console.log(`Add BULK DATA  3 ${data}`)

        var vehiclesBulkResponse = await postData(data, ApiURLs.VEHICLESBULK);
        console.log(`Add BULK DATA  4 ${vehiclesBulkResponse}`)

        if (vehiclesBulkResponse.status === 1) {
          dispatch({"type":"ADD_VEHICLES_SUCCESS"});
          dispatch(hideAddVehiclesModal());
          dispatch(vehiclesLisitingRequest());
        } else {
          dispatch({"type":"ADD_VEHICLES_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_VEHICLES_FAILED"});
  
      }
    };
  };




  export const vehiclesLisitingRequest = (page=1,pageSize=10,keyword='') => {

    return async (dispatch) => {

      const url = `${ApiURLs.VEHICLES}?offset=${page}&limit=${pageSize}&keyword=${keyword}`;
  

      console.log('CHECK:::::::',url,pageSize);
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_VEHICLES_REQUEST"});
      try {
        var vehiclesData = await fetchData(url);
        console.log(`response when we try to get vehicles  ${JSON.stringify(vehiclesData)}`)
        if (vehiclesData.status === 1) {
          dispatch({"type":"GET_VEHICLES_REQUEST_SUCCESS", "payload":vehiclesData.data.result,"total":vehiclesData.data.total});
        
        } else {
          dispatch({"type":"GET_VEHICLES_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_VEHICLES_REQUEST_FAILED"});
        console.log(`error while try to get vehicles  ${error}`)
      }
    }
  };



    export const deleteVehicles = (id) => {
      return async (dispatch) => {
    
        // dispatch();
        dispatch({"type":"DELETE_VEHICLES_REQUEST"});
        try {
    
  
          var vehiclesResponse = await deleteData(`${ApiURLs.VEHICLES}/${id}`);
          if (vehiclesResponse.status === 1) {
            dispatch({"type":"ADD_VEHICLES_SUCCESS"});
            dispatch(vehiclesLisitingRequest());
          } else {
            dispatch({"type":"ADD_VEHICLES_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_VEHICLES_FAILED"});
    
        }
      };
    };
  

